import Vue from 'vue'
import VueRouter from 'vue-router'
import Reparaciones from '../views/Reparaciones.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/reparaciones',
    name: 'Reparaciones',
    component: Reparaciones
  },
  {
    path: '/mantenimientos',
    name: 'Mantenimientos',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Mantenimientos.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
